<template>
  <v-dialog v-model="localDialog" width="60%" @update:modelValue="updateDialog" transition=""persistent :open-delay="0" :close-delay="0">
    <v-card>
        <v-card-title class="text-h6">
            <span>{{ isEntryMode ? 'Add Branch Module' : 'Update Branch Module' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-form @submit.prevent="submit" ref="BranchSetup">
              <v-row class="ma-0">
                  <v-col cols="12" md="6" lg="6" class="pa-2">
                    <v-autocomplete
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      v-model="company_id.value.value"
                      :items="getCompanyList.filter(item=> item.status == 1)"
                      :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"    
                      @update:modelValue="branch_id.value.value = ''"                                                                             
                      item-value="id"
                      :error-messages="company_id.errorMessage.value"
                      clearable                        
                    >
                      <template #label>
                        Company <span class="text-red-accent-4">*</span>
                      </template>
                    </v-autocomplete>  
                  </v-col>

                  <v-col cols="12" md="6" lg="6" class="pa-2">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="branch_id.value.value"
                        :items="getBranchList.filter(item => item.company_id == company_id.value.value)"
                        :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
                        item-value="id"
                        :error-messages="branch_id.errorMessage.value"
                      @update:modelValue="(value) => { this.tempId = value; }"
                        clearable                        
                      >
                        <template #label>
                          Branch <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete> 
                  </v-col> 
                  

                  <v-col cols="12" class="pa-2 mt-1">
                        <div class="d-flex align-center mb-1">
                          <v-checkbox
                            density="compact"
                            hide-details
                            color="primary"
                            :model-value="isAllModulesSelected"
                            @update:model-value="toggleAllModules"
                            class="mr-2"
                          >
                            <template v-slot:label>
                              <strong>Select All Modules</strong>
                            </template>
                          </v-checkbox>
                        </div>
                        <v-divider class="mb-1"></v-divider>
                        <v-row class="ma-0">
                          <v-col
                            v-for="(module, index) in getAvailableModules"
                            :key="module.id"
                            cols="6"
                            md="4"
                            lg="4"
                            class="pa-0"
                          >
                            <v-checkbox
                              :id="'module_' + module.id"
                        density="compact"
                              hide-details
                              color="primary"
                              :model-value="selectedModules.includes(module.id)"
                              @update:model-value="toggleModule(module.id, $event)"
                              class="ma-0"
                      >
                              <template v-slot:label>
                                <span class="text-caption">{{ module.module.name }} {{ module.module.code ? `- ${module.module.code}` : '' }}</span>
                        </template>
                            </v-checkbox>
                          </v-col>
                        </v-row>
                        <div v-if="companies_module_id.errorMessage.value" class="text-red text-caption mt-1">
                          {{ companies_module_id.errorMessage.value }}
                        </div>
                    </v-col>
                    
                    <v-checkbox                            
                        label="Active"
                        v-model="status.value.value"
                        :error-messages="status.errorMessage.value"
                        density="compact"
                        variant="outlined"
                        hide-details
                        single-line
                        color="primary"
                        value="1"
                    ></v-checkbox>
                    <input v-model="branch_companies_module_id.value.value" type="hidden">
              </v-row>

              <v-divider></v-divider>
              <v-card-actions>
                  <v-layout class="justify-end">
                      <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                        <v-btn 
                        class="bg-brand w-15 ms-2"  
                        variant="flat" 
                        type="submit"
                        >
                        {{ isEntryMode ? 'Save' : 'Update' }}
                        </v-btn>
                  </v-layout>
              </v-card-actions>
            </v-form>
        </v-card-text>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'

export default {
  name: 'BranchModuleSetup',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        branch_id: '',
        companies_module_id: '',
        status: '1',
        company_id: null,
        branch_companies_module_id: null,
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: '',
      loading: false,
      isEntryMode: true,
      tempId: '',
      getReservedModule: [],
      availableModule: [],
      selectedModules: []
    }
  },
  computed: {
    getCompanyList() {
      return this.$store.getters.getCompanyList;
    },
    getBranchList() {
        return this.$store.getters.getBranchList;
    },
    getCompanyModuleList() {
        return this.$store.getters.getCompanyModuleList;
    },
    getBranchModuleList() {
        return this.$store.getters.getBranchModuleList;
    },
    getTempBranchModuleList() {
        return this.$store.getters.getTempBranchModuleList;
    },
    getAvailableModules() {
      if (!this.company_id.value.value) {
        return [];
      }
      // Show all modules for the selected company
      return this.getCompanyModuleList.filter(item => item.company_id == this.company_id.value.value);
    },
    getAssignedModuleIds() {
      // Get all companies_modules IDs that are already assigned to the selected branch
      if (!this.branch_id.value.value) {
        return [];
      }
      return this.getBranchModuleList
        .filter(item => item.branch_id == this.branch_id.value.value)
        .map(item => item?.companies_modules?.id);
    },
    isAllModulesSelected() {
      if (this.getAvailableModules.length === 0) return false;
      return this.getAvailableModules.every(module => this.selectedModules.includes(module.id));
    }
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.branch_id.setValue(newData.branch_id || '', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.company_id.setValue(newData.branch?.company_id || '', false)
        this.branch_id.setValue(newData.branch_id || '', false)
        this.branch_companies_module_id.setValue(newData.id || '', false);
        
        // Set selected modules - for edit mode, show all assigned modules for this branch
        if (newData.branch_id) {
          // Get all companies_modules IDs already assigned to this branch
          const assignedModules = this.getBranchModuleList
            .filter(item => item.branch_id == newData.branch_id)
            .map(item => item.companies_modules.id);

          this.$nextTick(() => {
            this.selectedModules = [...assignedModules];
            this.companies_module_id.setValue([...assignedModules], false);
          });
        } else {
          this.selectedModules = [];
          this.companies_module_id.setValue([], false);
        }
      },
      deep: true,
      immediate: true
    },
    'company_id.value.value'() {
      // When company changes, clear selections
      this.selectedModules = [];
      this.companies_module_id.setValue([], false);
    },
    'branch_id.value.value'(newVal) {
      if (newVal) {
        // When branch is selected, load all companies_modules IDs already assigned to this branch
        const assignedModules = this.getBranchModuleList
          .filter(item => item.branch_id == newVal)
          .map(item => item.companies_modules.id);

        this.$nextTick(() => {
          this.selectedModules = [...assignedModules];
          this.companies_module_id.setValue([...assignedModules], false);
        });
      } else {
        // If branch is cleared, clear selections
        this.selectedModules = [];
        this.companies_module_id.setValue([], false);
      }
    }
  },
  created() {
      if(this.$store.getters.getCompanyList.length == 0){
            this.loading = true;
                this.$store.dispatch('getCompanyList').then((response) => {
                this.loading = false;
            })
        };
        if(this.$store.getters.getBranchList.length == 0){
            this.loading = true;
                this.$store.dispatch('getBranchList').then((response) => {
                this.loading = false;
            })
        };
        // if(this.$store.getters.getCompanyModuleList.length == 0){this.$store.dispatch('getCompanyModuleList')};
        this.$store.dispatch('getCompanyModuleList');
        
    },
  methods: {
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.selectedModules = [];
        this.companies_module_id.setValue([], false);
        this.$emit('update:dialog', false);
    },
    showAvailableModule(branch_id, currentModuleId = null){
      // This method is no longer needed since we show all modules
      // But keeping it for backward compatibility if called elsewhere
      if (!branch_id) return;
      // Just set all company modules as available
      const companyId = this.company_id.value.value;
      if (companyId) {
        this.availableModule = this.getCompanyModuleList.filter(item => item.company_id == companyId);
      this.$store.commit('SET_TEMP_BRANCH_MODULE_LIST', this.availableModule);
      }
    },
    toggleModule(moduleId, value) {
      if (value) {
        if (!this.selectedModules.includes(moduleId)) {
          this.selectedModules.push(moduleId);
        }
      } else {
        this.selectedModules = this.selectedModules.filter(id => id !== moduleId);
      }
      // Update the form field with the selected modules
      this.$nextTick(() => {
        this.companies_module_id.setValue([...this.selectedModules], true);
      });
    },
    toggleAllModules(value) {
      if (value) {
        this.selectedModules = this.getAvailableModules.map(module => module.id);
      } else {
        this.selectedModules = [];
      }
      // Update the form field with the selected modules
      this.$nextTick(() => {
        this.companies_module_id.setValue([...this.selectedModules], true);
      });
    }
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
          branch_id: yup.number().positive().integer().required().label('Branch'),
          company_id: yup.number().positive().integer().required().label('Company'),
          companies_module_id: yup.array().of(yup.number().positive().integer()).min(1, 'Please select at least one module').required().label('Module'),
      }),

    });

    const company_id = useField('company_id');
    const branch_id = useField('branch_id');
    const companies_module_id = useField('companies_module_id');
    const status = useField('status');
    const branch_companies_module_id = useField('branch_companies_module_id');
    const errorMessages  = ref('');
    const loading  = ref('');
    const buttonText  = ref('');
    buttonText.value = 'Save';
    const store = useStore();

    const submit = handleSubmit((values) => {

      // console.log(values);
      // return;
        // Ensure companies_module_id is an array
        if (!Array.isArray(values.companies_module_id)) {
            values.companies_module_id = [values.companies_module_id];
        }
        
        // For edit mode, we need to pass branch_companies_module_id to delete old records
        // The backend will handle the update by deleting old and inserting new
        
        store.dispatch("saveUpdateBranchModule", values)
            .then((response) => {
                resetForm();
                emit('update:dialog', false);
                toast.success(response.data.message);
                loading.value = true;
                store.dispatch('getBranchModuleList')
                    .then(data => {
                        loading.value = false;
                    })
                    .catch(error => {
                        loading.value = false;
                        toast.error(error.response.data.message);   
                    })
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
      submit,
      company_id,
      branch_id,
      companies_module_id,
      status,
      errorMessages,
      branch_companies_module_id,
      buttonText,
      resetForm,
      loading
    }
  },
  mounted() {
  }
}
</script>

